import * as tslib_1 from "tslib";
import { default as GroupNode } from './GroupNode';
import { observer } from 'mobx-react';
import { shallowCompare } from 'office-ui-fabric-react/lib/Utilities';
import { getGroupsStore } from 'owa-groups-shared-store';
import * as React from 'react';
var GroupListNode = /** @class */ (function (_super) {
    tslib_1.__extends(GroupListNode, _super);
    function GroupListNode(props) {
        var _this = _super.call(this, props) || this;
        _this.onContextMenu = function (evt, group) {
            var _a = _this.props, onContextMenu = _a.onContextMenu, groupId = _a.groupId;
            if (onContextMenu) {
                evt.stopPropagation();
                evt.preventDefault();
                var groupSmtp = groupId.toLowerCase();
                var groups = getGroupsStore().groups;
                if (groups.has(groupSmtp)) {
                    var group_1 = groups.get(groupSmtp);
                    onContextMenu(evt, group_1);
                }
            }
        };
        return _this;
    }
    GroupListNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !shallowCompare(this.props, nextProps);
    };
    GroupListNode.prototype.render = function () {
        return (React.createElement(GroupNode, { selectGroup: this.props.selectGroup, isSelected: this.props.isSelected, renderRightCharm: this.props.renderRightCharm, renderRightCharmHover: this.props.renderRightCharmHover, chevronProps: null, customIcon: null, displayName: this.props.displayName, groupId: this.props.groupId, onContextMenu: this.onContextMenu, renderCustomTreeNodeDisplay: null, customData: this.props.customData }));
    };
    GroupListNode = tslib_1.__decorate([
        observer
    ], GroupListNode);
    return GroupListNode;
}(React.Component));
export default GroupListNode;
//# sourceMappingURL=GroupListNode.js.map